export default __webpack_public_path__ + "static/media/icon-node-tipo-video.ecb668df.svg";